// extracted by mini-css-extract-plugin
export default {"text":"GetText_text__1vp3F","first_h1":"GetText_first_h1__Ib4wS","second_h1":"GetText_second_h1__UmFLK","first_h2":"GetText_first_h2__CXGf8","second_h2":"GetText_second_h2__xDWlG"};